module.exports = __webpack_public_path__ + "img/611-42dfb3.png";